import {DirectUpload} from "@rails/activestorage";
import PropTypes from "prop-types";
import {useEffect, useMemo, useState} from "react";
import {createNotification} from "app/actions/notifications";
import Loading from "components/helpers/loading";
import {getDirectUploadUrl} from "lib/active-storage";
import useAppContext from "lib/hooks/use-app-context";

// TODO: Allow cancelling upload/overriding
function FileField({
  onChange,
  multiple = false,
  name,
  value = null,
  ...props
}) {
  const {dispatch} = useAppContext();
  const directUploadUrl = useMemo(getDirectUploadUrl, []);
  const [fileName, setFileName] = useState(null);
  const [uploading, setUploading] = useState(false);
  const onFileChange = (e) => {
    const file = e.target.files[0];

    if(!file) {
      setFileName(null);
      setUploading(false);
      onChange({target: {name, type: "file", value: ""}});
      return;
    }

    setFileName(file.name);
    setUploading(true);

    const upload = new DirectUpload(file, directUploadUrl);

    upload.create((error, blob) => {
      if(error) {
        dispatch(createNotification({content: error, type: "danger"}));
        onChange({target: {name, type: "file", value: ""}});
      } else {
        onChange({target: {name, type: "file", value: blob.signed_id}});
      }
      setUploading(false);
    });
  };
  const onRemove = () => onChange({target: {name, type: "file", value: ""}});

  useEffect(() => {
    if(!value) { setFileName(null); }
  }, [value]);

  useEffect(() => {
    // eslint-disable-next-line no-console
    multiple && console.log("multiple not supported yet");
  }, [multiple]);

  return (
    <>
      {uploading && (
        <div className="input-group-prepend">
          <div className="input-group-text"><Loading size="1x" /></div>
        </div>
      )}
      <div className="custom-file">
        <input
          className="custom-file-input"
          type="file"
          onChange={onFileChange}
          value=""
          {...props}
        />
        <label className="custom-file-label" htmlFor={props.id}>{fileName || "Choose file"}</label>
      </div>
      {value && (
        <div className="input-group-append">
          <button className="btn btn-danger" onClick={onRemove} type="button">Remove</button>
        </div>
      )}
    </>
  );
}

FileField.propTypes = {
  id: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};

export default FileField;
